/* TOPのHOT ITEM枠: BoostAIの検索APIでお気に入り数上位を取得し、テーマ純正product-cardで並べ直す (WEBWASTENOT-101)
 *
 * 背景:
 * - 対象コレクション(急上昇アイテム)は1700件超あり、Liquidのfor(paginateなしのcollection.products)は
 *   50件までしか取得できないため、Liquid単体では「全体の中の本当の上位」を正しく並べられない。
 * - BoostのFilter API(services.mybcapps.com/bc-sf-filter/filter)は認証不要・CORS許可されており、
 *   コレクションページのソート設定(Sort by options)と同じ並び順を全件対象に取得できる。
 * - Boost管理画面でこのソート設定が削除/変更されると、エラーにならず別の並び順がサイレントに
 *   返ってくることがある。取得値が単調減少になっているかをここで検証し、怪しければ何もしない
 *   (SSRでの表示のまま = collection.productsの先頭から出す、壊れた見た目にはしない)。
 * - お気に入り数は累計なので、出品90日以内の商品に絞って古い商品の居座りを防ぐ (WEBWASTENOT-184)。
 */
(function () {
  'use strict';

  var SORT_PARAM = 'number-extra-sort2-descending';
  var SORT_FIELD = 'number_extra_sort2';
  var MIN_FAVORITE_COUNT = 3;
  var MAX_AGE_DAYS = 90;
  var FETCH_LIMIT = 70;
  var CACHE_TTL_MS = 30 * 60 * 1000;
  var REVEAL_TIMEOUT_MS = 10000;
  var READY_CLASS = 'hot-item-sort-ready';

  function reveal(container) {
    container.classList.add(READY_CLASS);
  }

  function extractSectionId(element) {
    var section = element.classList.contains('shopify-section') ? element : element.closest('.shopify-section');
    return section ? section.id.replace('shopify-section-', '') : null;
  }

  function cacheKey(collectionId) {
    return 'wnHotItemSort:v2:' + collectionId;
  }

  function readCache(collectionId) {
    try {
      var raw = localStorage.getItem(cacheKey(collectionId));
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || !Array.isArray(data.ids) || Date.now() - data.ts > CACHE_TTL_MS) return null;
      return data.ids;
    } catch (e) {
      return null;
    }
  }

  function writeCache(collectionId, ids) {
    try {
      localStorage.setItem(cacheKey(collectionId), JSON.stringify({ ids: ids, ts: Date.now() }));
    } catch (e) {}
  }

  function isMonotonicDescending(values) {
    for (var i = 1; i < values.length; i++) {
      if (values[i] > values[i - 1]) return false;
    }
    return true;
  }

  function fetchTopFavoriteIds(shopDomain, collectionId, limit) {
    var url = 'https://services.mybcapps.com/bc-sf-filter/filter'
      + '?shop=' + encodeURIComponent(shopDomain)
      + '&collection_scope=' + encodeURIComponent(collectionId)
      + '&sort=' + SORT_PARAM
      + '&limit=' + FETCH_LIMIT;
    return fetch(url, { priority: 'low' }).then(function (res) {
      if (!res.ok) throw new Error('Boost filter API error: ' + res.status);
      return res.json();
    }).then(function (data) {
      var products = (data && data.products) || [];
      if (products.length === 0) throw new Error('Boost filter API returned no products');
      var values = products.map(function (p) { return Number(p[SORT_FIELD]); });
      if (!isMonotonicDescending(values) || !(values[0] >= MIN_FAVORITE_COUNT)) {
        throw new Error('unexpected sort order from Boost, skip overriding SSR content');
      }
      var cutoff = Date.now() - MAX_AGE_DAYS * 24 * 60 * 60 * 1000;
      var recent = products.filter(function (p) { return new Date(p.created_at).getTime() >= cutoff; });
      if (recent.length === 0) throw new Error('no products listed within ' + MAX_AGE_DAYS + ' days');
      return recent.slice(0, limit).map(function (p) { return String(p.id); });
    });
  }

  function fetchProductCardsDoc(ids, sectionId) {
    var q = ids.map(function (id) { return 'id:' + id; }).join(' OR ');
    var url = Shopify.routes.root + 'search?type=product&q=' + encodeURIComponent(q) + '&section_id=' + sectionId;
    return fetch(url, { priority: 'low' }).then(function (res) { return res.text(); }).then(function (html) {
      return new DOMParser().parseFromString(html, 'text/html');
    });
  }

  function reorderAndRender(container, doc, ids) {
    var source = doc.querySelector('[data-hot-item-sort]');
    if (!source || source.children.length === 0) return false;

    var cardById = {};
    Array.prototype.forEach.call(source.children, function (card) {
      var link = card.querySelector('a[data-gtm-item-id]');
      var id = link && link.getAttribute('data-gtm-item-id');
      if (id) cardById[id] = card;
    });

    var ordered = ids.map(function (id) { return cardById[id]; }).filter(Boolean);
    if (ordered.length === 0) return false;

    // 枠の先頭(SP用サムネイル画像)・末尾(VIEW ALLカード)は <product-card> 要素ではないため、
    // 実商品カードだけを取得した順に差し替え、それ以外はそのまま残す
    var anchor = container.querySelector('.view-all-card');
    var existingCards = Array.prototype.filter.call(container.children, function (el) {
      return el.tagName === 'PRODUCT-CARD';
    });

    var fragment = document.createDocumentFragment();
    ordered.forEach(function (node) { fragment.appendChild(document.importNode(node, true)); });

    if (anchor) {
      container.insertBefore(fragment, anchor);
    } else {
      container.appendChild(fragment);
    }
    existingCards.forEach(function (el) { el.remove(); });

    return true;
  }

  function run(container) {
    // 取得が失敗/長引いても枠を隠したままにしないための保険 (WEBWASTENOT-101)
    var revealTimer = setTimeout(function () { reveal(container); }, REVEAL_TIMEOUT_MS);
    function revealNow() {
      clearTimeout(revealTimer);
      reveal(container);
    }

    var collectionId = container.getAttribute('data-collection-id');
    var limit = parseInt(container.getAttribute('data-limit'), 10) || 8;
    var sectionId = extractSectionId(container);
    if (!collectionId || !sectionId) { revealNow(); return; }

    var cached = readCache(collectionId);
    var idsPromise = cached
      ? Promise.resolve(cached)
      : fetchTopFavoriteIds(Shopify.shop, collectionId, limit).then(function (ids) {
          writeCache(collectionId, ids);
          return ids;
        });

    idsPromise.then(function (ids) {
      return fetchProductCardsDoc(ids, sectionId).then(function (doc) {
        var ok = reorderAndRender(container, doc, ids);
        if (ok && window._swat && typeof window._swat.initializeActionButtons === 'function') {
          window._swat.initializeActionButtons('[data-hot-item-sort]');
        }
      });
    }).catch(function (error) {
      console.error('HOT ITEM sort:', error);
    }).then(revealNow);
  }

  function start() {
    // 画面内に入るのを待たず、ページ読み込み直後から取得を始める
    // (下の方のセクションなので、表示されるまでに正しい順番を間に合わせたい)
    document.querySelectorAll('[data-hot-item-sort]').forEach(run);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
